/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @deprecated please copy this code to your implementation instead, this function will be removed in the next major version of this package.
 * @param timer
 */
export function unrefTimer(timer: { unref(): unknown } | number): void {
  if (typeof timer !== 'number') {
    timer.unref();
  }
}
